export default __webpack_public_path__ + "static/media/branding-logo.c2403b3e.svg";